export enum LayoutActivityType {
    NEWS = 'news',
    POST = 'post',
    TASK = 'task',
    VISIT = 'visit',
    SURVEY_TASK = 'surveyTask',
    CHALLENGE = 'challenge',
}

export enum ModalsType {
    NEW_ACTIVITY = 'new-activity',
    NEW_SURVEY_TASK = 'new-survey-task',
    FILTERS = 'filters',
    NEWS_EXECUTION = 'news-execution',
    NEWS_APPROVAL = 'news-approval',
    TASK_EXECUTION = 'task-execution',
    VISIT_EXECUTION = 'visit-execution',
    TASK_APPROVAL = 'task-approval',
    SEARCH = 'search',
    NEW_RESOURCE = 'new-resource',
    NEW_FORUM = 'new-forum',
    NEW_QUICK_LINK = 'new-quick-link',
    NEW_PHOTO = 'new-photo',
    SAVE_PICTURE = 'save-picture',
    NEW_ALBUM = 'new-album',
    NEW_VIRTUAL_STORE = 'new-virtual-store',
    GRSD = 'grsd',
    REWARD = 'reward',
    CHALLENGE_EXECUTION = 'challenge-execution'
}

export interface LayoutNewActivity {
    showNewActivity: boolean
    activityType: LayoutActivityType
}

export interface LayoutModalsState {
    type: ModalsType
    subType?: string
    props: Object
}

export interface SocialHubConfiguration {
    showSocialHub: boolean
    showAchievements: boolean
    showBadges: boolean
    showRecognitions: boolean
    showChallenges: boolean
    showRewardsCredits: boolean
    showBirthday: boolean
    showYearsOfEmployment: boolean
    showUserRanking: boolean
    showStoreRanking: false
}

export interface LayoutState {
    isApp: boolean
    showSidebar: boolean
    showNavbar: boolean
    showFabButton: boolean
    showBackToTop: boolean
    modals: LayoutModalsState
    bottomFabButton: string
    isChatbotOpen: boolean
    breadcrumbs: any[]
    breadcrumbNavigationProps: any
    socialHubConfiguration: SocialHubConfiguration
}
